import { themes, hooks, utils } from 'kb-shared';
import React from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../redux';
import styled from 'styled-components';
import { cardBoxShadow } from '../../styled';

const { colors, breakpoints, fonts } = themes;
const { useContactInfo } = hooks;

type Props = {
  className?: string;
  employerPhone?: string;
  employer?: boolean;
  isLoggedIn: boolean;
};

const ContactDiv = (props: Props) => {
  const { className, employerPhone, employer, isLoggedIn } = props;
  const contactInfo = useContactInfo(process.env.REACT_APP_ENV, isLoggedIn);

  const { email, numberLabel, number } = contactInfo;

  function formatPhoneNumber(phoneNumberString: string) {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{0,2})(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
    }
    return null;
  }

  let phoneLabel = numberLabel;
  let phoneData = number;
  let emailData = email;

  if (employer) {
    emailData = utils.KBContacts.employeeBenefitsEmail;
    phoneData = employerPhone || utils.KBContacts.defaultNumber;
    //@ts-ignore
    phoneLabel = formatPhoneNumber(phoneData);
  }

  return (
    <Container className={className}>
      <Label>Email</Label>
      <Text>
        <a href={`mailto:${emailData}`}>{emailData}</a>
      </Text>

      <Label>Phone</Label>
      <Text>
        <a href={`tel:${phoneData}`}>{phoneLabel}</a>
      </Text>
    </Container>
  );
};

const Label = styled.div`
  ${fonts.FoundersGrotesk};
  color: ${colors.KBNight};
  font-size: 14px;
`;

const Text = styled.div`
  ${fonts.DomaineDisplay};
  color: ${colors.KBNight};
  font-size: 18px;
  font-weight: 400;
  text-decoration: none;

  @media (min-width: ${breakpoints.tabletLandscape}) {
    font-size: 24px;
  }
`;

const Container = styled.div`
  background-color: ${colors.KBWhite};
  border-left: 8px solid ${colors.KBYellow};
  box-shadow: ${cardBoxShadow};
  padding: 12px 24px 0 ${24 - 8}px;

  ${Text} {
    padding-bottom: 12px;
  }
`;

const mapStateToProps = ({ patient }: ReduxState) => ({
  employer: patient.patient.patientMembership?.employer,
  employerPhone: patient.patient.patientMembership?.employerPhone,
  isLoggedIn: patient.isLoggedIn
});

export default connect(mapStateToProps)(ContactDiv);
